module.exports = __webpack_public_path__ + "static/media/new-mongo.f3b6fd2b.svg";